import baseApi from "./RootBaseApi";
import { ApiResponse } from "@/types/api.types";
import {
  GuestVisibilityItem,
  UpdateGuestVisibilityPayload,
} from "@/types/GuestVisibility.type";

export const GuestVisibilityService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getGuestVisibility: builder.query<
      ApiResponse<GuestVisibilityItem[]>,
      void
    >({
      query: () => ({
        url: "/guest-visibility",
        method: "GET",
      }),
      providesTags: ["GuestVisibility"],
    }),
    updateGuestVisibility: builder.mutation<
      ApiResponse<GuestVisibilityItem[]>,
      UpdateGuestVisibilityPayload
    >({
      query: (payload) => ({
        url: "/guest-visibility",
        method: "PUT",
        data: payload,
      }),
      invalidatesTags: ["GuestVisibility"],
    }),
  }),
});

export const { useGetGuestVisibilityQuery, useUpdateGuestVisibilityMutation } =
  GuestVisibilityService;
